<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform" xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
    <div class="row">
        <div class="col-12 mb-4">
            <v-card elevation="0">
                <v-card-title>
                    {{ formTitle }}
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-form ref="form"  :lazy-validation="lazy" enctype="multipart/form-data">
                    <v-stepper v-model="e1" elevation="0">
                        <v-stepper-header class="elevation-0">
                            <v-stepper-step
                                    :complete="e1 > 1"
                                    step="1"
                            >
                                {{$t('marchand.info')}}
                            </v-stepper-step>

                            <v-divider></v-divider>

                            <v-stepper-step
                                    :complete="e1 > 2"
                                    step="2"
                            >
                                {{$t('marchand.docs')}}
                            </v-stepper-step>

                        </v-stepper-header>
                        <v-text-field  v-if="submitting" color="primary" loading disabled></v-text-field>
                        <v-alert type="info">
                            Les informations de votre compte seront vérifiées puis validées. Veillez à fournir les informations exactes de votre entreprise pour ne pas ralentir le processus de validation.                        </v-alert>
                        <v-alert v-if="errors.operation" dense outlined type="error">
                            {{errors.operation}}
                        </v-alert>
                        
                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <v-col >
                                    <v-row >
                                        <v-col cols="12" sm="4">
                                            <v-text-field  v-model="editedItem._web_site" :label="$t('marchand.site_web')"  single-line solo ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4" >
                                            <v-text-field  :rules="CompanyRules"  v-model="editedItem._company" :label="$t('marchand.company') "  single-line solo ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4" >
                                            <v-text-field   v-model="editedItem._acronyme" :label="$t('marchand.acronyme')" single-line solo  ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4" >
                                            <v-text-field :rules="[rules.required,rules.email]"  v-model="editedItem._email" :label="$t('marchand.email')"  single-line solo ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4" >
                                            <v-text-field   v-model="editedItem._base_url_site_web" single-line solo  :label="$t('marchand.base_url')"  required></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="4" >
                                            <v-select :rules="CategorieRules" @change="categorieChanged"   v-model="editedItem._categorie_id" item-text="_name" item-value="_id" :items="category_marchands" :label="$t('marchand.categorie')" single-line solo dense required></v-select>
                                        </v-col>
                                        <v-col cols="12" sm="6" >
                                            <v-text-field  v-model="editedItem._url_checkout" :label="$t('marchand.url_checkout')" single-line solo  ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" >
                                            <v-text-field   v-model="editedItem._url_success" :label="$t('marchand.url_success')" single-line solo  ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="6" >
                                            <v-text-field   v-model="editedItem._url_error" :label="$t('marchand.url_error')" single-line solo   ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-select :rules="countryRules" @change="countryChanged"   v-model="editedItem.country" item-text="_name" item-value="_id" :items="countries" :label="$t('marchand.pays')" single-line solo  ></v-select>
                                        </v-col>
                                    </v-row>
                                </v-col>

                                <v-col class="text-right px-5" cols="12">
                                <v-btn :disabled="!editedItem._company  || !editedItem._email || !editedItem._categorie_id || !editedItem.country"
                                       color="primary"
                                       @click="e1 = 2"
                                >
                                    {{$t('marchand.continue')}}

                                </v-btn>
                            </v-col>

                            </v-stepper-content>

                            <v-stepper-content step="2">
                                <v-card-text>

                                    <v-form  ref="form" v-model="valid" :lazy-validation="lazy"  enctype="multipart/form-data">
                                        <v-col style="margin-top: 2%">

                                            <v-row >
                                                <v-col cols="12" sm="6" >
                                                    <h6>{{$t('documents.document_passport_label')}}</h6>
                                                    <v-text-field :rules="numRules" required v-model="editedItem._numCard" :label="$t('documents.document_passport_label')" :placeholder="$t('documents.document_passport_label')" type="text" single-line solo></v-text-field>
                                                </v-col>
                                                <v-col  cols="12" sm="6" >
                                                    <h6>{{$t('documents.document_passport_file')}}</h6>
                                                    <v-file-input
                                                            v-model="editedItem._fileCar"  id="card" :rules="editedIndex === -1?fileRules:[]"   prepend-icon="mdi-camera"
                                                            accept="image/*,application/pdf"
                                                            :show-size="1000"
                                                            solo>
                                                        <template v-slot:selection="{ index}">
                                                            <v-chip
                                                                    v-if="index < 2"
                                                                    label
                                                                    small
                                                            >
                                                                Cliqué pour choisir votre fichier
                                                            </v-chip>

                                                        </template>
                                                    </v-file-input>

                                                </v-col>

                                                <v-col style:="" cols="12" sm="6" >
                                                    <h6>{{$t('documents.document_rccm_label')}}</h6>

                                                    <v-text-field  :rules="numrRules" required v-model="editedItem._numRCCM" :label="$t('documents.document_rccm_label')" :placeholder="$t('documents.document_rccm_label')" type="text" single-line solo></v-text-field>
                                                </v-col>
                                                <v-col  cols="12" sm="6">
                                                    <h6>{{$t('documents.document_rccm_file')}} </h6>
                                                    <v-file-input
                                                            v-model="editedItem._fileRCC" :rules="editedIndex === -1?filerRules:[]"    accept="application/pdf"
                                                            :show-size="1000"
                                                            prepend-icon="mdi-paperclip"
                                                            solo>
                                                        <template v-slot:selection="{ index}">
                                                            <v-chip
                                                                    v-if="index < 2"
                                                                    label
                                                                    small
                                                            >
                                                                Cliqué pour choisir votre fichier (pdf)
                                                            </v-chip>

                                                        </template>
                                                    </v-file-input>


                                                </v-col>
                                                <v-col cols="12" sm="6" >
                                                    <h6>{{$t('documents.document_ifu_label')}}</h6>

                                                    <v-text-field :rules="numiRules" required v-model="editedItem._numIFU" :label="$t('documents.document_ifu_label')" :placeholder="$t('documents.document_ifu_label')" type="text" single-line solo></v-text-field>
                                                </v-col>
                                                <v-col  cols="12" sm="6" >
                                                    <h6>{{$t('documents.document_ifu_file')}}</h6>
                                                    <v-file-input
                                                            v-model="editedItem._fileIFU"  :rules="editedIndex === -1?fileiRules:[]"                                                             accept="application/pdf"
                                                            :show-size="1000"
                                                            prepend-icon="mdi-paperclip"
                                                            solo>
                                                        <template v-slot:selection="{ index}">
                                                            <v-chip
                                                                    v-if="index < 2"
                                                                    label
                                                                    small
                                                            >
                                                                Cliqué pour choisir votre fichier (pdf)
                                                            </v-chip>

                                                        </template>
                                                    </v-file-input>

                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-form>
                                </v-card-text>

                                <v-col cols="12" class="px-5">
                                    <v-alert type="warning">
                                        En cliquant sur ENREGISTRER, vous vous engagez à fournir les informations exactes de votre entreprise et nous donner le droit de les détenir conformément à la politique d'utilisation de notre plateforme.                                    </v-alert>
                                </v-col>

                                <v-col class="text-right px-5" cols="12">
                                <v-btn class="mr-3"
                                        color="secondary"
                                        @click="e1 = 1"
                                >
                                    {{$t('marchand.retour')}}
                                </v-btn>
                                <v-btn :disabled="!editedItem._numCard || !editedItem._fileCar || !editedItem._numRCCM || !editedItem._fileRCC || !editedItem._numIFU || !editedItem._fileIFU || mis" color="primary" @click.prevent="save">{{$t('save')}}</v-btn>
                            </v-col>
                            </v-stepper-content>


                        </v-stepper-items>
                    </v-stepper>


                </v-form>

            </v-card>
        </div>
    </div>

</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "NouveauCompe",
        data () {
            return {
                picker: new Date().toISOString().substr(0, 10),
                tabs: null,
                bars: [
                    { class: 'primary', dark: true },
                ],
                submitting:false,
                valid:true,
                lazy:false,
                mis:false,
                e1: 1,
                errors: {},
                countryHasChanged:false,
                categorieHasChanged:false,
                search: '',
                dialog: '',
                id:undefined,
                headers: [

                ],
                editedIndex: -1,
                editedItem: {
                    _user_id: '',
                    _web_site: '',
                    _company: '',
                    _acronyme: '',
                    _email: '',
                    _base_url_site_web: '',
                    _categorie_id: '',
                    _url_checkout: '',
                    _url_success: '',
                    country: '',
                    _url_error: '',
                    _numCard: '',
                    _fileCard: '',
                    _numRCCM: '',
                    _fileRCCM: '',
                    _fileCar: '',
                    _fileRCC: '',
                    _fileIF: '',
                    _numIFU: '',
                    _fileIFU: '',
                    _valide: false,
                    _created_at: 0,
                    _id:0
                },
                defaultItem: {
                    _user_id: '',
                    _web_site: '',
                    _company: '',
                    _acronyme: '',
                    _email: '',
                    _base_url_site_web: '',
                    _categorie_id: '',
                    _url_checkout: '',
                    _url_success: '',
                    _url_error: '',
                    country: '',
                    _numCard: '',
                    _fileCard: '',
                    _numRCCM: '',
                    _fileRCCM: '',
                    _fileCar: '',
                    _fileRCC: '',
                    _fileIF: '',
                    _numIFU: '',
                    _fileIFU: '',
                    _valide: false,
                    _created_at: 0,
                    _id:0
                },
                Web_SiteRules: [
                    v => !!v ||   this.$t('marchand.site_web_required'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                CompanyRules: [
                    v => !!v ||   this.$t('marchand.company_required'),
                ],
                AcronymeRules: [
                    v => !!v ||  this.$t('marchand.acronyme_required'),
                ],
                rules: {
                    required: value => !!value ||  this.$t('field_required'),
                    min: v => v!==undefined && v.length >= 8 || this.$t('min_8_caracters'),
                    match: v => v == this.password || this.$t('password_mismatch'),
                    email: v => (v.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) ||  this.$t('invalid_email'),
                    tel: v => (v.match(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s/0-9]*$/g)) ||  this.$t('invalid_phone'),
                    //email: v => (v.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) ||  this.$t('invalid_email'),
                },
                Base_url_siteRules: [
                    v => !!v ||   this.$t('marchand.base_url_required'),
                ],
                CategorieRules: [
                    v => !!v ||   this.$t('marchand.categorie_required'),
                ],
                Url_checkoutRules: [
                    v => !!v ||   this.$t('marchand.url_checkout_required'),
                ],
                Url_successRules: [
                    v => !!v ||   this.$t('marchand.url_success_required'),
                ],
                Url_errorRules: [
                    v => !!v ||    this.$t('marchand.url_error_required'),
                ],


                codeRules: [
                    v => !!v || 'Code required',
                ],
                numRules: [
                    v => !!v || this.$t('documents.num_passport_required'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                numrRules: [
                    v => !!v || this.$t('documents.num_rccm_required'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                numiRules: [
                    v => !!v || this.$t('documents.num_ifu_required'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                fileRules: [
                    v => !!v || this.$t('documents.file_passport_required'),
                    v => !v || v.size < 2000000 || 'Taille maximimun 2 MB!',

                ],

                fileiRules: [
                    v => !!v || this.$t('documents.file_ifu_required'),
                    v => v.type==='application/pdf' || this.$t('invalid_file'),
                    v => !v || v.size < 2000000 || 'Taille maximimun 2 MB!',



                ],
                filerRules: [
                    v => !!v || this.$t('documents.file_rccm_required'),
                    v => v.type==='application/pdf' || this.$t('invalid_file'),
                    v => !v || v.size < 2000000 || 'Taille maximimun 2 MB!',

                ],
                countryRules: [
                    v => !!v ||    this.$t('marchand.pays_required'),
                ],

            }
        },
        computed: {
            user : function(){
                return this.$store.getters.auth
            },

            formTitle () {
                return this.editedIndex === -1 ? this.$t('Nouveau compte marchand') : this.$t('Modifier information')
            },
            country:function () {
                return (this.user.country===null || this.user.country==undefined) ? {text:"Votre pays",value:"1"} :{text:this.user.country._name, value:this.user.country._id}
            },
            ...mapState('countries/',['countries']),
            ...mapState('marchands/',['marchand']),
            ...mapState('documents/',['document']),
            ...mapState('category_marchands/',['category_marchands']),


        },
        mounted(){
            this.initialize();
        },
        created(){
            this.checkisDashboard()
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        methods: {
            categorieChanged(){
                this.categorieHasChanged = true;
            },
            initialize () {
                this.$store.dispatch('marchands/getMarchandOne').then(response => {
                    console.log('Marchand',response)
                });
                this.$store.dispatch('documents/getDocumentOne').then(response => {
                    console.log('Mon document',response)
                });
                this.$store.dispatch('category_marchands/getCategorie_Marchand').then(response => {
                    console.log('category_marchands',response)
                });
                this.$store.dispatch('countries/getCountries').then(response => {
                    console.log(response)
                });
            },
            countryChanged(){
                this.countryHasChanged = true;

            },
            close () {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            save () {
                const router = this.$router;
                let VueBox = this;
                this.submitting = true;
                let data = new FormData();
                this.mis=true;
                data.append("user_id",this.$store.getters.auth._id);
                data.append("web_site",this.editedItem._web_site);
                data.append("company",this.editedItem._company);
                data.append("acronyme",this.editedItem._acronyme);
                data.append("email",this.editedItem._email);
                data.append("base_url_site_web",this.editedItem._base_url_site_web);
                data.append("url_checkout",this.editedItem._url_checkout);
                data.append("url_success",this.editedItem._url_success);
                data.append("url_error",this.editedItem._url_error);
                let cat = this.editedItem._categorie_id;
                let pays = this.editedItem.country;

                if ( this.categorieHasChanged){
                    data.append("_categorie_id",cat);
                }
                if ( this.countryHasChanged){
                    data.append("country",pays);
                }
                if(this.editedItem._numCard)
                    data.append("numCard",this.editedItem._numCard);
                if(this.editedItem._numRCCM)
                    data.append("numRCCM",this.editedItem._numRCCM);
                if(this.editedItem._numIFU)
                    data.append("numIFU",this.editedItem._numIFU);
                console.log('Carte',this.editedItem._fileRCC)
                if (this.editedItem._fileCar===undefined) {
                    data.append("fileCard", this.document._fileCard);
                }
                else{
                    data.append("fileCard", this.editedItem._fileCar);

                }
                if (this.editedItem._fileRCC) {
                    data.append("fileRCCM",this.editedItem._fileRCC);
                }
                if (this.editedItem._fileIFU) {
                    data.append("fileIFU",this.editedItem._fileIFU);
                }
                this.$store.dispatch('nouveau_marchands/set',data).then((response)=>{
                    console.log('set nouveau response',response)
                    this.submitting = false;
                    if (response.error===true){
                        alert(response.message)
                        this.errors.operation=response.message;
                    }else{
                        this.editedItem = this.defaultItem;
                        VueBox.toast('success','Enrégistrement effectué avec succès');
                        setTimeout(() => {
                            router.push('/');
                        }, 1000);
                    }
                })
            },

            validate () {
                this.$refs.form.validate()
            },
            reset () {
                this.$refs.form.reset()
            },
            checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },
            fileChange() {
                console.log( this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file){
                return file.substr(file.lastIndexOf('/')+1)
            },
        },
    }
</script>
